import { defineComponent as _defineComponent } from 'vue'
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { textField } from 'ah-common-lib/src/form/models';
import { Beneficiary } from 'ah-api-gateways';
import { FormEvent, FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { computed, reactive, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentReferenceForm',
  props: {
    reference: { default: '' },
    beneficiary: null,
    narrow: { type: [String, Boolean], default: false }
  },
  emits: ["update:reference"],
  setup(__props: any, { expose, emit }: { emit: ({
  /**
   * - update:reference (payload: string | null) : .sync-able emission of reference value
   */
  (e: 'update:reference', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { reference: string, beneficiary?: Beneficiary, narrow: string | boolean };



const txReferenceForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'referenceForm',
    fieldType: 'form',
    fields: [
      textField('reference', '', {
        required: false,
        defaultValue: props.reference,
        showLengthCounter: true,
        maxLength: 18,
      }),
    ],
  }),
  validation: null,
});

function onReferenceChange() {
  if (txReferenceForm.form.reference) {
    txReferenceForm.form.reference = props.reference?.slice(0, 18) || '';
  }
}



const isNarrow = computed(() => props.narrow !== false);

const valid = computed(() => !(txReferenceForm.validation && txReferenceForm.validation.$invalid));

function emitValue() {
  emit('update:reference', txReferenceForm.form.reference);
}

watch(
  () => props.reference,
  () => {
    onReferenceChange();
  },
  { immediate: true }
);

watch(
  () => props.beneficiary,
  () => {
    if (props.beneficiary) {
      onReferenceChange();
      // Value needs to be emmitted in the next JS frame, to allow all watchers to run beforehand
      setTimeout(() => emitValue());
    }
  },
  { immediate: true }
);

function touchForms() {
  if (txReferenceForm.validation) {
    submitForm(txReferenceForm.validation);
  }
}

function onFormEvent(event: FormEvent) {
  if (event.event === 'form-field-set-value') {
    emitValue();
  }
}

expose({ touchForms, valid });

return { __sfc: true,props, txReferenceForm, onReferenceChange, emit, isNarrow, valid, emitValue, touchForms, onFormEvent }
}

})